document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="A1WhatsInTheBox-"]');

  sections.forEach((section) => {
    const scrollTopBtn = section.querySelector('[data-scroll-top]');
    const modal = section.querySelector('[data-video-modal]');
    const openVideoBtn = section.querySelector('[data-open-video]');
    const closeVideoBtns = section.querySelectorAll('[data-close-video]');
    const video = section.querySelector('[data-video-element]');
    const revealItems = section.querySelectorAll('.a1box-reveal');
    const floatWrap = section.querySelector('[data-float-wrap]');

    if (scrollTopBtn) {
      scrollTopBtn.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }

    const openModal = () => {
      if (!modal) return;
      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
      modal.setAttribute('aria-hidden', 'false');
    };

    const closeModal = () => {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      modal.setAttribute('aria-hidden', 'true');

      if (video) {
        video.pause();
      }

      setTimeout(() => {
        modal.hidden = true;
      }, 280);
    };

    if (openVideoBtn) {
      openVideoBtn.addEventListener('click', openModal);
    }

    closeVideoBtns.forEach((btn) => {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('a1box-visible');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.12 });

      revealItems.forEach((item, index) => {
        item.style.transitionDelay = `${Math.min(index * 70, 320)}ms`;
        observer.observe(item);
      });
    } else {
      revealItems.forEach((item) => item.classList.add('a1box-visible'));
    }

    if (floatWrap && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let start = null;

      const animateFloat = (timestamp) => {
        if (!start) start = timestamp;
        const t = (timestamp - start) / 1000;
        const y = Math.sin(t * 0.85) * -7;
        floatWrap.style.transform = `translate3d(0, ${y}px, 0)`;
        requestAnimationFrame(animateFloat);
      };

      requestAnimationFrame(animateFloat);
    }
  });
});